export default "__VITE_ASSET__DRNuJ_KS__"